<template>
    <div class="modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ isCreating ? 'Crear tópico' : 'Editar tópico' }}</h5>
                    <button type="button" @click="closeModal" style="background: none; border: none; font-size: 1.5rem; line-height: 1;">&times;</button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="handleSubmit">
                        <div class="form-group">
                            <label for="topicTypeInput">Tipo:</label>
                            <select
                                v-model="formData.topic_type"
                                id="topicTypeInput"
                                class="form-control"
                                required
                            >
                                <option
                                    v-for="topicType in topicTypes"
                                    :key="topicType"
                                    :value="topicType"
                                >
                                    {{ topicType }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group mt-2">
                            <label for="topicNameInput">Tópico:</label>
                            <input
                                type="text"
                                v-model="formData.topic_name"
                                id="topicNameInput"
                                class="form-control"
                                required
                            />
                        </div>
                        <hr>
                        <div class="d-flex justify-content-end">
                            <button type="button" class="btn btn-danger me-2" @click="closeModal">Cancelar</button>
                            <button type="submit" class="btn btn-success">Guardar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';

export default {
    name: 'MachineTopicModal',
    props: {
        formData: {
            type: Object,
            required: true,
        },
        isCreating: {
            type: Boolean,
            default: false,
        },
        topicTypes: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
        };
    },
    methods: {
        handleSubmit() {
            this.isCreating ? this.createMachineTopic() : this.updateMachineTopic()
        },
        createMachineTopic() {
            axios.post('/api/machine-topic', this.formData)
                .then(response => {
                    showCustomSuccessSweetAlert('Tópico creado correctamente');
                    this.$emit('form-submitted');
                    this.closeModal();
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        updateMachineTopic() {
            let request = {
                topic_name: this.formData.topic_name,
                topic_type: this.formData.topic_type,
            };
            axios.patch(`/api/machine-topic/${this.formData.topic_id}/update`, request)
                .then(response => {
                    showCustomSuccessSweetAlert('Tópico editado correctamente');
                    this.$emit('form-submitted');
                    this.closeModal();
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        closeModal() {
            this.$emit('close-modal');
        },
    },
};
</script>